module.exports = global.config = {
    server_url: "https://tapovanaserver.tapovanaresorts.com/tapovanawebsiteserver/",
    booking_url: "https://booking.tapovanaresorts.com/",
    public_path_url: "https://www.tapovanaresorts.com/",
    // server_url: "http://localhost:3001/tapovanawebsiteserver/",
    // booking_url: "http://localhost:3002/",
};
